import { prepareOptions } from './utils/prepareOptions';
import { configureScope } from './utils/configureScope';
import { InternalErrorMonitor } from './InternalErrorMonitor';
/**
  Adds initalization props that are mandatory in Sentry 7
 */
export const createSafeSentryOptions = (Sentry, options = {}) => ({
    ...options,
    transport: options.transport ??
        (typeof Sentry.makeFetchTransport !== 'undefined'
            ? Sentry.makeFetchTransport
            : undefined),
    stackParser: options.stackParser ??
        (typeof Sentry.defaultStackParser !== 'undefined'
            ? Sentry.defaultStackParser
            : undefined),
    integrations: options.integrations ??
        (typeof Sentry.getDefaultIntegrations === 'function'
            ? Sentry.getDefaultIntegrations({})
            : Sentry.defaultIntegrations),
});
/**
 * Creates new Sentry hub, to be used inside nested libraries (when you want them to track errors into a different DSN)
 *
 * @param options
 * @return sentryHub
 */
export function createHub(options) {
    const { Sentry } = options;
    const clientOptions = createSafeSentryOptions(Sentry, prepareOptions(options));
    const sentryClient = new Sentry.BrowserClient(clientOptions);
    const sentryHub = new Sentry.Hub(sentryClient);
    configureScope(sentryHub, options);
    return new InternalErrorMonitor(sentryHub, options.appName);
}
//# sourceMappingURL=createHub.js.map